import React, { Component } from 'react';
import UserThumb from '../../assets/user-thumb.png';
import Input from '../../components/Input';
import { FaTimes } from 'react-icons/fa';
import Select from 'react-select';
import { observer } from 'mobx-react';
import userStore from '../../stores/userStore';
import { Bars } from 'react-loader-spinner';

const AddNewUserModal = observer(class AddNewUserModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            employeeName: '',
            email: '',
            designation: null,
            image: null,
            loading: false,
        };
    }

    handleDesignationSelect = (data) => {
        this.setState({ designation: data });
    };

    handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const img = new Image();
            img.src = URL.createObjectURL(file);
            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');

                canvas.width = 400;
                canvas.height = 400;

                ctx.drawImage(img, 0, 0, 400, 400);

                canvas.toBlob((blob) => {
                    const newFile = new File([blob], `${file.lastModified}-${Math.floor(Math.random() * 99999)}.${file.name.split('.').pop()}`, {
                        type: file.type,
                        lastModified: file.lastModified,
                    });
                    this.setState({ image: newFile });
                }, file.type);
            };
        }
    };

    validateFields = () => {
        const { employeeName, email, designation } = this.state;
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        return (
            employeeName.trim() !== '' &&
            emailPattern.test(email) &&
            designation !== null
        );
    };

    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown);
    }

    handleKeyDown = (event) => {
        if (event.key === 'Escape') {
            userStore.setAddNewUserModalVisible(false);
        }
    };

    render() {
        const {
            employeeName,
            email,
            designation,
            image,
            loading
        } = this.state;

        const designationOptions = [
            { value: 'Admin', label: 'Admin' },
            { value: 'Contributor', label: 'Contributor' },
            { value: 'Intern', label: 'Intern' },
        ];

        return (
            <div className="fixed inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50">
                <div className="flex relative flex-col overflow-scroll w-full lg:w-1/2 h-full lg:h-[90%]  py-6 px-5 lg:px-10 overflow-y-scroll overflow-x-hidden bg-white shadow-lg">

                    <div className='flex  flex-col z-10'>
                        <span className='font-normal text-lg text-[#21272A] my-6'>Profile Photo</span>
                        <div className='flex flex-1 flex-row'>
                            <div className='flex flex-row items-center gap-6'>
                                {image ? (
                                    <img src={URL.createObjectURL(image)} className='w-[100px] h-[100px] rounded-full' alt='Profile' />
                                ) : (
                                    <img src={UserThumb} className='w-[100px] h-[100px] rounded-full' alt='Profile' />
                                )}
                                <div className='flex flex-col justify-center items-center'>
                                    <button
                                        onClick={() => document.getElementById('fileInput').click()}
                                        className='border-[2px] px-4 py-2 border-[#000000] text-base font-normal text-[#000000]'>
                                        Upload Photo
                                    </button>
                                    <input
                                        id='fileInput'
                                        type='file'
                                        accept='image/*'
                                        style={{ display: 'none' }}
                                        onChange={this.handleFileChange}
                                    />
                                    <button onClick={() => this.setState({ image: null })} className='text-base font-normal text-[#000000] mt-2'>remove</button>
                                </div>
                            </div>
                            <div className='w-[1px] h-full bg-[#DDE1E6] mx-12 hidden lg:flex'></div>
                            <div className='flex-1 flex-col hidden lg:flex'>
                                <span className='text-lg font-normal text-[#21272A]'>Image requirements:</span>
                                <span className='text-sm font-normal text-[#21272A] mt-2'>- Your face or company logo</span>
                            </div>
                        </div>

                        <div className='h-[1px] w-full bg-[#DDE1E6] mt-6'></div>
                        <span className='font-normal text-lg text-[#21272A] my-6'>User Details</span>

                        <div className='flex flex-col lg:flex-row gap-4 mt-4'>
                            <Input
                                title="User Name"
                                onChange={(e) => this.setState({ employeeName: e.target.value })}
                                value={employeeName}
                            />
                        </div>

                        <div className='flex flex-col lg:flex-row gap-4 mt-4'>
                            <Input
                                type="email"
                                title="E-mail"
                                onChange={(e) => this.setState({ email: e.target.value })}
                                value={email}
                            />
                            <div className='flex flex-1 flex-col justify-center'>

                                <span className='text-sm font-normal text-[#21272A] my-2'>Designation</span>
                                <Select
                                    options={designationOptions}
                                    placeholder="Select..."
                                    value={designation}
                                    onChange={this.handleDesignationSelect}
                                    isSearchable={true}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            backgroundColor: '#F0EFEF',
                                            paddingTop: 5,
                                            paddingBottom: 5,
                                            boxShadow: 'none',
                                            border: '1px solid #ccc',
                                            '&:hover': {
                                                border: '1px solid #ccc',
                                            },
                                        }),
                                        indicatorsContainer: (provided) => ({
                                            ...provided,
                                            display: 'none',
                                        }),
                                    }}
                                />
                            </div>
                        </div>

                        <div className="mt-14 flex justify-end gap-2">
                            <button
                                disabled={(!this.validateFields() || loading)}
                                className={`text-white font-medium text-base px-6 py-2 rounded-md ${this.validateFields() ? 'bg-[#130D0D]' : 'bg-gray-400'}`}
                                onClick={async () => {
                                    this.setState({ loading: true });
                                    await userStore.createUser(this.state)
                                        .then(data => {
                                            this.setState({ loading: false });
                                            userStore.setAddNewUserModalVisible(false);
                                        })
                                        .catch(error => {
                                            this.setState({ loading: false });
                                            console.error('Error creating profile:', error);
                                        });
                                }}
                            >
                                {
                                    !loading && 'Save'
                                }

                                <Bars
                                    height="25"
                                    width="25"
                                    color="#F89A1F"
                                    ariaLabel="bars-loading"
                                    wrapperStyle={{
                                        fill: "black",
                                    }}

                                    wrapperClass="fill-black"
                                    visible={loading}
                                />

                            </button>

                            <button onClick={() => {
                                userStore.setAddNewUserModalVisible(false);
                            }} className='absolute right-5 top-4'>
                                <FaTimes size={20} color='black'></FaTimes>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
});

export default AddNewUserModal;
